import { Route, Routes } from "react-router-dom";
import { lazy } from "react";
import { AdminLayout } from "../components/layouts/AdminLayout";
const DashboardRoute = lazy(() => import("./authenticated/admin/Dashboard"));
const SettingsNotifications = lazy(() => import("../features/settings/notifications"));
const Settings = lazy(() => import("../features/settings"));
const SettingsProfile = lazy(() => import("../features/settings/profile"));
const ChangePassword = lazy(() => import("../features/settings/change-password"));
const SettingsAccount = lazy(() => import("../features/settings/account"));
const SettingsAppearance = lazy(() => import("../features/settings/appearance"));
const AppStats = lazy(() => import("../features/reports/application/stats"));
const ReportAdminError = lazy(() => import("../features/report-admin-error"));
const NotFoundAuthed = lazy(() => import("./authenticated/admin/NotFound"));
const FacultyMaint = lazy(() => import("@/features/admin/maintenance/qualification/faculty"));
const CampusList = lazy(() => import("@/features/admin/maintenance/qualification/campus"));
const InstitutionStructureList = lazy(() => import("@/features/admin/maintenance/qualification/institution-structure"));
const InstitutionList = lazy(() => import("@/features/admin/maintenance/qualification/institution"));
const InstitutionTypeList = lazy(() => import("@/features/admin/maintenance/qualification/institution-type"));
const InstitutionStatusList = lazy(() => import("@/features/admin/maintenance/qualification/institution-status"));
const EntryTermMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/entry-term"));
const EntryYearMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/entry-year"));
const EntryLevelMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/entry-level"));
const CareerDirectionMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/career-direction"));
const ProgrammeTypeMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/programme-type"));
const ProgrammeDurationMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/programme-duration"));
const ProgrammeQualifierMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/programme-qualifier"));
const PrerequisitesTypeMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/prerequisites-type"));
const PrerequisiteSetMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/prerequisite-set"));
const PrerequisiteGroupMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/prerequisite-group"));
const PrerequisiteComponentMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/prerequisite-component"));
const CountryMaintenance = lazy(() => import("@/features/admin/maintenance/general/country"));
const PostalCodeMaintenance = lazy(() => import("@/features/admin/maintenance/general/postal-code"));
const ProvinceMaintenance = lazy(() => import("@/features/admin/maintenance/general/province"));
const DisabilityMaintenance = lazy(() => import("@/features/admin/maintenance/general/disability"));
const RelationshipMaintenance = lazy(() => import("@/features/admin/maintenance/general/relationship"));
const SuburbMaintenance = lazy(() => import("@/features/admin/maintenance/general/suburb"));
const PermitVisaMaintenance = lazy(() => import("@/features/admin/maintenance/general/permit-visa"));
const RecentActivityMaintenance = lazy(() => import("@/features/admin/maintenance/general/recent-activity"));
const LetterTypeMaintenance = lazy(() => import("@/features/admin/maintenance/general/letter-type"));
const AlertMessageMaintenance = lazy(() => import("@/features/admin/maintenance/general/alert-message"));
const AdhocMessageMaintenance = lazy(() => import("@/features/admin/maintenance/communication/adhoc-message"));
const AccessRouteMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/access-route"));
const TransactionTypeMaintenance = lazy(() => import("@/features/admin/maintenance/finance/transaction-type"));
const TransactionRateMaintenance = lazy(() => import("@/features/admin/maintenance/finance/transaction-rate"));
const FinanceCapture = lazy(() => import("@/features/admin/maintenance/finance/finance-capture"));
const StatementMaintenance = lazy(() => import("@/features/admin/maintenance/finance/statement"));
const AggregateGroupAllocationMaintenance = lazy(() => import("@/features/admin/maintenance/examination/aggregate-group-allocation"));
const ExamCentreMaintenance = lazy(() => import("@/features/admin/maintenance/examination/exam-centre"));
const PointGroupAllocationMaintenance = lazy(() => import("@/features/admin/maintenance/examination/point-group-allocation"));
const PointRoutineSubjectAllocation = lazy(() => import("@/features/admin/maintenance/examination/point-routine-subject-allocation"));
const PointRoutineQualificationAllocation = lazy(() => import("@/features/admin/maintenance/examination/point-routine-qualification-allocation"));
const PassTypeMaintenance = lazy(() => import("@/features/admin/maintenance/examination/pass-type"));
const ExamImportsResultsMatchingMaintenance = lazy(() => import("@/features/admin/maintenance/examination/exam-imports-results-matching"));
const ApplicantMatricMatchingMaintenance = lazy(() => import("@/features/admin/maintenance/examination/applicant-matric-matching"));
const DocumentTypeMaintenance = lazy(() => import("@/features/admin/maintenance/general/document-type"));
const LookupCategoryMaintenance = lazy(() => import("@/features/admin/maintenance/general/lookup-category"));

const MenuGroupMaintenance = lazy(() => import("@/features/admin/maintenance/administration/menu-group"));
const UserGroupMaintenance = lazy(() => import("@/features/admin/maintenance/administration/user-group"));
const MenuItemMaintenance = lazy(() => import("@/features/admin/maintenance/administration/menu-item"));
const RoleMaintenance = lazy(() => import("@/features/admin/maintenance/administration/role"));
const MenuAccessMaintenance = lazy(() => import("@/features/admin/maintenance/administration/menu-access"));
const UserEmailMaintenance = lazy(() => import("@/features/admin/maintenance/administration/user-email"));
const UserRoleMaintenance = lazy(() => import("@/features/admin/maintenance/administration/user-role"));
const UserMaintenance = lazy(() => import("@/features/admin/maintenance/administration/user"));
const UserAccessMaintenance = lazy(() => import("@/features/admin/maintenance/administration/user-access"));
const ApplicantAudit = lazy(() => import("@/features/admin/audits/applicant"));
const TelephoneAudit = lazy(() => import("@/features/admin/audits/telephone"));
const EmailAudit = lazy(() => import("@/features/admin/audits/email"));
const AddressAudit = lazy(() => import("@/features/admin/audits/address"));
const YourselfAudit = lazy(() => import("@/features/admin/audits/yourself"));
const BiographicalAudit = lazy(() => import("@/features/admin/audits/biographical"));
const SchoolingAudit = lazy(() => import("@/features/admin/audits/schooling"));
const NOKAudit = lazy(() => import("@/features/admin/audits/nok"));
const FinanceAudit = lazy(() => import("@/features/admin/audits/finance"));
const ExamDetailsAudit = lazy(() => import("@/features/admin/audits/examdetails"));
const ExamResultsAudit = lazy(() => import("@/features/admin/audits/examresults"));
const AlertAudit = lazy(() => import("@/features/admin/audits/alert"));
const DocumentsAudit = lazy(() => import("@/features/admin/audits/documents"));
const PostSchoolAudit = lazy(() => import("@/features/admin/audits/postschool"));
const CountryAudit = lazy(() => import("@/features/admin/audits/country"));
const ProvinceAudit = lazy(() => import("@/features/admin/audits/province"));
const RelationshipAudit = lazy(() => import("@/features/admin/audits/relationship"));
const AlertMessageAudit = lazy(() => import("@/features/admin/audits/alertmessage"));
const PermitVisaAudit = lazy(() => import("@/features/admin/audits/permitvisa"));
const ProgrammeAudit = lazy(() => import("@/features/admin/audits/programme"));
const GuardianAudit = lazy(() => import("@/features/admin/audits/guardian"));
const LetterTypeAudit = lazy(() => import("@/features/admin/audits/lettertype"));
const DisabilityAudit = lazy(() => import("@/features/admin/audits/disability"));
const PostalCodeAudit = lazy(() => import("@/features/admin/audits/postalcode"));
const RecentActivityAudit = lazy(() => import("@/features/admin/audits/recentactivity"));
const SuburbAudit = lazy(() => import("@/features/admin/audits/suburb"));
const InstitutionAudit = lazy(() => import("@/features/admin/audits/institution"));
const InstitutionStructureAudit = lazy(() => import("@/features/admin/audits/institutionstructure"));
const InstitutionTypeAudit = lazy(() => import("@/features/admin/audits/institutiontype"));
const FacultyAudit = lazy(() => import("@/features/admin/audits/faculty"));
const CampusAudit = lazy(() => import("@/features/admin/audits/campus"));
const EntryYearAudit = lazy(() => import("@/features/admin/audits/entryyear"));
const EntryTermAudit = lazy(() => import("@/features/admin/audits/entryterm"));
const EntryLevelAudit = lazy(() => import("@/features/admin/audits/entrylevel"));
const ProgrammeTypeAudit = lazy(() => import("@/features/admin/audits/programmetype"));
const ProgrammeDurationAudit = lazy(() => import("@/features/admin/audits/programmeduration"));
const ProgrammeQualifierAudit = lazy(() => import("@/features/admin/audits/programmequalifier"));
const PrerequisiteTypeAudit = lazy(() => import("@/features/admin/audits/prerequisitetype"));
const TransactionRateAudit = lazy(() => import("@/features/admin/audits/transactionrate"));
const TransactionTypeAudit = lazy(() => import("@/features/admin/audits/transactiontype"));
const ContactAudit = lazy(() => import("@/features/admin/audits/contact"));
const ApplicantTotalsReport = lazy(() => import("@/features/admin/reports/applicant-totals"));
const ApplicantGeographicStatisticsReport = lazy(() => import("@/features/admin/reports/applicant-geographic-statistics"));
const ApplicantsPerQualificationReport = lazy(() => import("@/features/admin/reports/applicants-per-qualification"));
const ApplicantGenderPopAgeReport = lazy(() => import("@/features/admin/reports/applicant-gender-pop-age"));
const ApplicantGenderPopLangReport = lazy(() => import("@/features/admin/reports/applicant-gender-pop-lang"));
const InstitutionsStatisticsReport = lazy(() => import("@/features/admin/reports/institutions-statistics"));
const ApplicantStatisticsPerInstitutionReport = lazy(() => import("@/features/admin/reports/applicant-statistics-per-institution"));
const SchoolStatisticsReport = lazy(() => import("@/features/admin/reports/school-statistics"));
const ApplicantSummaryReport = lazy(() => import("@/features/admin/reports/applicant-summary"));
const ApplicationListingReport = lazy(() => import("@/features/admin/reports/application-listing"));
const ApplicationStatisticsReport = lazy(() => import("@/features/admin/reports/application-statistics"));
const EasyPay = lazy(() => import("@/features/admin/processing/easy-pay"));
const MyGate = lazy(() => import("@/features/admin/processing/mygate"));
const ApplicationModificationCapture = lazy(() => import("@/features/admin/processing/application-modification-capture"));
const ApplicationChangeOfMindCapture = lazy(() => import("@/features/admin/processing/application-change-of-mind-capture"));
const AlertPosting = lazy(() => import("@/features/admin/processing/alert-posting"));
const PointsCalculation = lazy(() => import("@/features/admin/processing/points-calculation"));
const DocumentView = lazy(() => import("@/features/admin/processing/document-view"));
const AnimalPersonalityMaintenance = lazy(() => import("@/features/admin/maintenance/general/animal-personality"));
const SchoolMaintenance = lazy(() => import("@/features/admin/maintenance/general/school"));
const OrganisationMaintenance = lazy(() => import("@/features/admin/maintenance/general/organisation"));
const StatusMaintenance = lazy(() => import("@/features/admin/maintenance/general/status"));
const ExamTypeMaintenance = lazy(() => import("@/features/admin/maintenance/examination/exam-type"));
const SubjectMaintenance = lazy(() => import("@/features/admin/maintenance/general/subject"));
const MenuGroupAudit = lazy(() => import("@/features/admin/audits/menugroup"));
const MenuItemAudit = lazy(() => import("@/features/admin/audits/menuitem"));
const MenuAccessAudit = lazy(() => import("@/features/admin/audits/menuaccess"));
const RoleAudit = lazy(() => import("@/features/admin/audits/role"));
const UserGroupAudit = lazy(() => import("@/features/admin/audits/usergroup"));
const UserRoleAudit = lazy(() => import("@/features/admin/audits/userrole"));
const UserEmailAudit = lazy(() => import("@/features/admin/audits/useremail"));
const UserAccessAudit = lazy(() => import("@/features/admin/audits/useraccess"));

const ProgrammeMaintenance = lazy(() => import("@/features/admin/maintenance/qualification/programme"));
const AdminAdhocCorrespondenceCommunication = lazy(() => import("@/features/admin/communication/adhoc-correspondence"));
const ResendMessages = lazy(() => import("@/features/admin/maintenance/communication/resend-messages"));
const ResendEmails = lazy(() => import("@/features/admin/maintenance/communication/resend-emails"));
const GenerateLetters = lazy(() => import("@/features/admin/maintenance/communication/generate-letters"));

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<DashboardRoute />} />

        <Route path="admin/maint">
          <Route path="administration">
            <Route path="menu-group" element={<MenuGroupMaintenance />} />
            <Route path="user-group" element={<UserGroupMaintenance />} />
            <Route path="menu-item" element={<MenuItemMaintenance />} />
            <Route path="role" element={<RoleMaintenance />} />
            <Route path="menu-access" element={<MenuAccessMaintenance />} />
            <Route path="user-email" element={<UserEmailMaintenance />} />
            <Route path="user-role" element={<UserRoleMaintenance />} />
            <Route path="user" element={<UserMaintenance />} />
            <Route path="user-access" element={<UserAccessMaintenance />} />
          </Route>

          <Route path="general">
            <Route path="country" element={<CountryMaintenance />} />
            <Route path="province" element={<ProvinceMaintenance />} />
            <Route path="disability" element={<DisabilityMaintenance />} />
            <Route path="relationship" element={<RelationshipMaintenance />} />
            <Route path="postal-code" element={<PostalCodeMaintenance />} />            
            <Route path="suburb" element={<SuburbMaintenance />} />
            <Route path="permit-visa" element={<PermitVisaMaintenance />} />
            <Route
              path="recent-activity"
              element={<RecentActivityMaintenance />}
            />
            <Route path="letter-type" element={<LetterTypeMaintenance />} />
            <Route
              path="animal-personality"
              element={<AnimalPersonalityMaintenance />}
            />
            <Route path="alert-message" element={<AlertMessageMaintenance />} />
            <Route path="document-type" element={<DocumentTypeMaintenance />} />
            <Route
              path="lookup-category"
              element={<LookupCategoryMaintenance />}
            />
            <Route path="organisation" element={<OrganisationMaintenance />} />
            <Route path="school" element={<SchoolMaintenance />} />
            <Route path="status" element={<StatusMaintenance />} />
            <Route path="subject" element={<SubjectMaintenance />} />
          </Route>

          <Route path="examination">
            <Route
              path="aggregate-group-allocation"
              element={<AggregateGroupAllocationMaintenance />}
            />
            <Route
              path="point-group-allocation"
              element={<PointGroupAllocationMaintenance />}
            />
            <Route path="exam-centre" element={<ExamCentreMaintenance />} />
            <Route path="pass-type" element={<PassTypeMaintenance />} />
            <Route path="exam-type" element={<ExamTypeMaintenance />} />
            <Route
              path="point-routine-subject-allocation"
              element={<PointRoutineSubjectAllocation />}
            />
            <Route
              path="point-routine-qualification-allocation"
              element={<PointRoutineQualificationAllocation />}
            />
          </Route>

          <Route
            path="exam-import-type"
            element={<ExamImportsResultsMatchingMaintenance />}
          />

          <Route
            path="applicant-matric-matching"
            element={<ApplicantMatricMatchingMaintenance />}
          />

          <Route path="qualification">
            <Route path="campus" element={<CampusList />} />
            <Route path="faculty" element={<FacultyMaint />} />
            <Route
              path="institution-structure"
              element={<InstitutionStructureList />}
            />
            <Route path="institution-type" element={<InstitutionTypeList />} />
            <Route
              path="institution-status"
              element={<InstitutionStatusList />}
            />

            <Route path="entry-term" element={<EntryTermMaintenance />} />
            <Route path="entry-year" element={<EntryYearMaintenance />} />
            <Route path="entry-level" element={<EntryLevelMaintenance />} />
            <Route path="programme" element={<ProgrammeMaintenance />} />
            <Route
              path="programme-type"
              element={<ProgrammeTypeMaintenance />}
            />
            <Route path="access-route" element={<AccessRouteMaintenance />} />

            <Route
              path="programme-duration"
              element={<ProgrammeDurationMaintenance />}
            />
            <Route
              path="programme-qualifier"
              element={<ProgrammeQualifierMaintenance />}
            />
            <Route
              path="prerequisites-type"
              element={<PrerequisitesTypeMaintenance />}
            />
            <Route
              path="prerequisite-set"
              element={<PrerequisiteSetMaintenance />}
            />
            <Route
              path="prerequisite-group"
              element={<PrerequisiteGroupMaintenance />}
            />
            <Route
              path="prerequisite-component"
              element={<PrerequisiteComponentMaintenance />}
            />
            <Route
              path="career-direction"
              element={<CareerDirectionMaintenance />}
            />
            <Route path="institution" element={<InstitutionList />} />
          </Route>
        </Route>

        <Route path="admin/maint/communication">
          <Route path="adhoc-message" element={<AdhocMessageMaintenance />} />
          <Route path="adhoc-correspondence" element={<AdminAdhocCorrespondenceCommunication />} />
          <Route path="resend-messages" element={<ResendMessages />} />
          <Route path="resend-emails" element={<ResendEmails />} />
          <Route path="generate-letters" element={<GenerateLetters />} />
        </Route>

        <Route path="admin/processing">
          <Route path="easy-pay" element={<EasyPay />} />
          <Route path="mygate" element={<MyGate />} />
          <Route
            path="application-modification-capture"
            element={<ApplicationModificationCapture />}
          />
          <Route
            path="application-change-of-mind-capture"
            element={<ApplicationChangeOfMindCapture />}
          />
          <Route path="alert-posting" element={<AlertPosting />} />
          <Route path="points-calculation" element={<PointsCalculation />} />
          <Route path="document-view" element={<DocumentView />} />
        </Route>

        <Route path="admin/reports">
          <Route path="applicant-totals" element={<ApplicantTotalsReport />} />
          <Route
            path="application-per-qualification"
            element={<ApplicantsPerQualificationReport />}
          />
          <Route
            path="applicant-geographic-statistics"
            element={<ApplicantGeographicStatisticsReport />}
          />
          <Route
            path="applicants-statistics/gender-pop-age"
            element={<ApplicantGenderPopAgeReport />}
          />
          <Route
            path="applicants-statistics/gender-pop-lang"
            element={<ApplicantGenderPopLangReport />}
          />
          <Route
            path="institutions-statistics"
            element={<InstitutionsStatisticsReport />}
          />
          <Route
            path="applicant-statistics-per-institution"
            element={<ApplicantStatisticsPerInstitutionReport />}
          />
          <Route
            path="school-statistics"
            element={<SchoolStatisticsReport />}
          />
          <Route
            path="applicant-summary"
            element={<ApplicantSummaryReport />}
          />
          <Route
            path="application-listing"
            element={<ApplicationListingReport />}
          />
          <Route
            path="application-statistics"
            element={<ApplicationStatisticsReport />}
          />
        </Route>

        <Route path="admin/maint/finance">
          <Route path="finance-capture" element={<FinanceCapture />} />
          <Route
            path="transaction-type"
            element={<TransactionTypeMaintenance />}
          />
          <Route
            path="transaction-rate"
            element={<TransactionRateMaintenance />}
          />
          <Route path="statement" element={<StatementMaintenance />} />
        </Route>

        <Route path="admin/audit">
          <Route path="maintenance-country-audit" element={<CountryAudit />} />
          <Route
            path="maintenance-province-audit"
            element={<ProvinceAudit />}
          />
          <Route
            path="maintenance-relationship-audit"
            element={<RelationshipAudit />}
          />
          <Route
            path="maintenance-alertmessage-audit"
            element={<AlertMessageAudit />}
          />
          <Route
            path="maintenance-lettertype-audit"
            element={<LetterTypeAudit />}
          />
          <Route
            path="maintenance-permitvisa-audit"
            element={<PermitVisaAudit />}
          />
          <Route
            path="maintenance-disability-audit"
            element={<DisabilityAudit />}
          />
          <Route
            path="maintenance-postalcode-audit"
            element={<PostalCodeAudit />}
          />
          <Route
            path="maintenance-recentactivity-audit"
            element={<RecentActivityAudit />}
          />
          <Route
            path="maintenance-institution-audit"
            element={<InstitutionAudit />}
          />
          <Route
            path="maintenance-institutionstructure-audit"
            element={<InstitutionStructureAudit />}
          />
          <Route
            path="maintenance-institutiontype-audit"
            element={<InstitutionTypeAudit />}
          />
          <Route path="maintenance-faculty-audit" element={<FacultyAudit />} />
          <Route path="maintenance-campus-audit" element={<CampusAudit />} />
          <Route
            path="maintenance-entryyear-audit"
            element={<EntryYearAudit />}
          />
          <Route
            path="maintenance-entryterm-audit"
            element={<EntryTermAudit />}
          />
          <Route
            path="maintenance-entrylevel-audit"
            element={<EntryLevelAudit />}
          />
          <Route
            path="maintenance-programmetype-audit"
            element={<ProgrammeTypeAudit />}
          />
          <Route
            path="maintenance-programmeduration-audit"
            element={<ProgrammeDurationAudit />}
          />
          <Route
            path="maintenance-programmequalifier-audit"
            element={<ProgrammeQualifierAudit />}
          />
          <Route
            path="maintenance-prerequisitetype-audit"
            element={<PrerequisiteTypeAudit />}
          />
          <Route path="maintenance-suburb-audit" element={<SuburbAudit />} />
          <Route
            path="maintenance-transactionrate-audit"
            element={<TransactionRateAudit />}
          />
          <Route
            path="maintenance-transactiontype-audit"
            element={<TransactionTypeAudit />}
          />
          <Route
            path="maintenance-menugroup-audit"
            element={<MenuGroupAudit />}
          />
          <Route
            path="maintenance-menuitem-audit"
            element={<MenuItemAudit />}
          />
          <Route
            path="maintenance-menuaccess-audit"
            element={<MenuAccessAudit />}
          />
          <Route path="maintenance-role-audit" element={<RoleAudit />} />
          <Route
            path="maintenance-usergroup-audit"
            element={<UserGroupAudit />}
          />
          <Route
            path="maintenance-userrole-audit"
            element={<UserRoleAudit />}
          />
          <Route
            path="maintenance-useremail-audit"
            element={<UserEmailAudit />}
          />
          <Route
            path="maintenance-useraccess-audit"
            element={<UserAccessAudit />}
          />
          <Route
            path="maintenance-programmetype-audit"
            element={<ProgrammeTypeAudit />}
          />
          <Route
            path="maintenance-programmeduration-audit"
            element={<ProgrammeDurationAudit />}
          />
          <Route path="maintenance-suburb-audit" element={<SuburbAudit />} />

          <Route
            path="applicant-telephone-audit"
            element={<TelephoneAudit />}
          />
          <Route path="applicant-yourself-audit" element={<YourselfAudit />} />
          <Route path="applicant-email-audit" element={<EmailAudit />} />
          <Route path="applicant-address-audit" element={<AddressAudit />} />
          <Route path="applicant-biographical-audit" element={<BiographicalAudit />}/>
          <Route path="applicant-audit" element={<ApplicantAudit />} />          
          <Route path="applicant-contact-audit" element={<ContactAudit />} />
          <Route path="applicant-schooling-audit" element={<SchoolingAudit />} />
          <Route path="applicant-nok-audit" element={<NOKAudit />} />
          <Route path="applicant-finance-audit" element={<FinanceAudit />} />
          <Route path="applicant-schooling-audit" element={<SchoolingAudit />} />
          <Route path="applicant-nok-audit" element={<NOKAudit />} />
          <Route path="applicant-finance-audit" element={<FinanceAudit />} />
          <Route path="applicant-examdetails-audit" element={<ExamDetailsAudit />} />
          <Route path="applicant-alert-audit" element={<AlertAudit />} />
          <Route
            path="applicant-examresults-audit"
            element={<ExamResultsAudit />}
          />
          <Route
            path="applicant-documents-audit"
            element={<DocumentsAudit />}
          />
          <Route
            path="applicant-programme-audit"
            element={<ProgrammeAudit />}
          />
          <Route path="applicant-guardian-audit" element={<GuardianAudit />} />
          <Route
            path="applicant-postschool-audit"
            element={<PostSchoolAudit />}
          />
          <Route path="applicant-guardian-audit" element={<GuardianAudit />} />
          <Route
            path="applicant-postschool-audit"
            element={<PostSchoolAudit />}
          />
        </Route>

        <Route path="settings" element={<Settings />}>
          <Route index element={<SettingsProfile />} />
          <Route path="change-password" element={<ChangePassword />} />
          <Route path="account" element={<SettingsAccount />} />
          <Route path="appearance" element={<SettingsAppearance />} />
          <Route path="notifications" element={<SettingsNotifications />} />
        </Route>
        <Route
          path="reports/application/application-stats"
          element={<AppStats />}
        />
        <Route path="report-admin-error" element={<ReportAdminError />} />
        <Route path="*" element={<NotFoundAuthed />} />
      </Route>
    </Routes>
  );
};
